import MainLayout from "../components/layouts/MainLayout";
import MainProfileComponent from "../components/dancer/profile/MainProfileComponent";

const ProfilePage = () => {
    return <>
        <MainLayout>
            <MainProfileComponent/>
        </MainLayout>
    </>
}

export default ProfilePage